import {
  MANAGEMENT_OFFICE_TYPE,
  SUB_MANAGEMENT_OFFICE_TYPE,
  INSTALLATION_OFFICE_TYPE,
  OPERATION_OFFICE_TYPE,
  DEPARTMENT_OFFICE_TYPE
} from "@/services/consts"
import i18n from "@/lang/i18n";

interface officeType {
  id: number;
  name: string;
  type: string;
}

export const MANAGEMENT_OFFICE:officeType = {
  "id": 1,
  "name": i18n.global.t('pages.userRoles.search.managementOffice'),
  "type": MANAGEMENT_OFFICE_TYPE
}

export const SUB_MANAGEMENT_OFFICE:officeType = {
  "id": 2,
  "name": i18n.global.t('pages.userRoles.search.subManagementOffice'),
  "type": SUB_MANAGEMENT_OFFICE_TYPE
}

export const INSTALLATION_OFFICE:officeType = {
  "id": 3,
  "name": i18n.global.t('pages.userRoles.search.installationOffice'),
  "type": INSTALLATION_OFFICE_TYPE
}

export const OPERATION_OFFICE:officeType = {
  "id": 4,
  "name": i18n.global.t('pages.userRoles.search.operationOffice'),
  "type": OPERATION_OFFICE_TYPE
}

export const DEPARTMENT:officeType = {
  "id": 5,
  "name": i18n.global.t('pages.userRoles.search.department'),
  "type": DEPARTMENT_OFFICE_TYPE
}